import { useTheme } from "@reactive-resume/hooks";
import { cn } from "@reactive-resume/utils";

type Props = {
  size?: number;
  className?: string;
  minimized?: boolean;
};

export const TheResumeLogo = ({ size = 32, className, minimized = false }: Props) => {
  // const { isDarkMode } = useTheme();

  // if (isDarkMode) {
  //   return (
  //     <img
  //       src="/logo/theResumeDark.svg"
  //       width={size}
  //       alt="theResume"
  //       className={cn("rounded-sm", className)}
  //     />
  //   );
  // }

  if (minimized) {
    return (
      <img
        src="/logo/theResumeIcon.png"
        width={size}
        height={size}
        alt="theResume"
        className={cn("rounded-sm object-contain", className)}
      />
    );
  }

  return (
    <img
      src="/logo/theResumeLight.png"
      width={size}
      alt="theResume"
      className={cn("rounded-sm object-contain", className)}
    />
  );
};
